module.exports = __webpack_public_path__ + "static/media/not-found-top.c9b2c199.svg";